import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AccomodationGuard implements CanActivate {
    constructor(private route: Router) {

    }

    canActivate(): boolean {
        if (sessionStorage.getItem("Accomodation")==null || sessionStorage.getItem("Accomodation") != "true" || sessionStorage.getItem("GUID")!="DBB7A467-FFFA-4C3B-81BB-C7E4E2EEF22B") {
            this.route.navigate(['/', 'login']);
            sessionStorage.clear();
            return false;
        }
        else {
            return true;
        }
    }
}